module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-equilibrio-kr/detalles-kr-modal/detalles-kr-modal.component.scss
// module id = ./src/app/components/reporte-equilibrio-kr/detalles-kr-modal/detalles-kr-modal.component.scss
// module chunks = main